import React, { useState, useEffect } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider';

const SpeakerList = () => {
  const [speakers, setSpeakers] = useState([]); 
  const {id} = useParams () ;

  const navigate = useNavigate();
  const {API} = useStateContext () ;

  useEffect(() => {
    const fetchSpeakers = async () => {
      try {
        const response = await AxiosClient.get(`/conference/${id}/speakers`);
        setSpeakers(response.data); 
        console.log(response.data)  ;
      } catch (error) {
        console.error('Error fetching speakers:', error);
      }
    };

    fetchSpeakers();
  }, [id]);

  const moveSpeakerUp = (index) => {
    if (index > 0) {
      const newSpeakers = [...speakers];
      [newSpeakers[index - 1], newSpeakers[index]] = [
        newSpeakers[index],
        newSpeakers[index - 1],
      ];
      setSpeakers(newSpeakers);
    }
  };

  const moveSpeakerDown = (index) => {
    if (index < speakers.length - 1) {
      const newSpeakers = [...speakers];
      [newSpeakers[index], newSpeakers[index + 1]] = [
        newSpeakers[index + 1],
        newSpeakers[index],
      ];
      setSpeakers(newSpeakers);
    }
  };

  const saveRanks = async () => {
    try {
      const updatePromises = speakers.map((speaker, index) => {
        const newRank = index + 1;
        return AxiosClient.put(`/speakers/update_rank/${speaker.id}`, { rank: newRank });
      });

      await Promise.all(updatePromises);
      console.log('Ranks updated successfully!');
      navigate(-1);
    } catch (error) {
      console.error('Error updating ranks:', error);
    }
  };

  return (
    <div className="table-responsive">
      <h2 className="title p-4">Speaker List</h2>
      <table className="table table-striped">
        <thead className="text-primary">
          <tr>
          <th className="text-center">image</th>

            <th className="text-center">Name</th>
            <th className="text-center">Title</th> 
             
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {speakers.map((speaker, index) => (
            <tr
              key={speaker.id}
              className={`text-center ${
                index % 2 === 0 ? 'bg-gray-50' : 'bg-white' // Alternating row colors
              } transition-bg duration-1000`}
            >
             <td> 
              <img
                  src={API + speaker.image}
                  alt={speaker.name}
                  className=" avatar avatar-lg p-0 "
                />
              </td>
              <td>
                {speaker.name}</td>
              <td>{speaker.title}</td>
              <td>
                <button className="btn btn-info btn-sm m-2" onClick={() => moveSpeakerUp(index)}>
                  Move Up
                </button>
                <button className="btn btn-danger btn-sm m-2" onClick={() => moveSpeakerDown(index)}>
                  Move Down
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="btn btn-success m-2" onClick={saveRanks}>
        Save Ranks
      </button>
      <button className="btn btn-dark m-2" onClick={() => navigate(-1)}>
        Cancel
      </button>
    </div>
  );
};

export default SpeakerList;
